var map = {
	"./": 36,
	"./App": 49,
	"./App.css": 97,
	"./App.js": 49,
	"./Pages": 26,
	"./Pages.js": 26,
	"./Utils": 6,
	"./Utils.js": 6,
	"./config/Config": 68,
	"./config/Config.js": 68,
	"./config/GearButton.css": 121,
	"./config/ModalMenu.css": 120,
	"./config/ajuda/Ajuda": 69,
	"./config/ajuda/Ajuda.css": 122,
	"./config/ajuda/Ajuda.js": 69,
	"./config/compartilhar/Compartilhar": 70,
	"./config/compartilhar/Compartilhar.css": 123,
	"./config/compartilhar/Compartilhar.js": 70,
	"./creditos/Creditos": 65,
	"./creditos/Creditos.css": 116,
	"./creditos/Creditos.js": 65,
	"./data/Chikungunya": 58,
	"./data/Chikungunya.js": 58,
	"./data/Combate": 54,
	"./data/Combate.js": 54,
	"./data/DataController": 52,
	"./data/DataController.js": 52,
	"./data/Dengue": 55,
	"./data/Dengue.js": 55,
	"./data/Febre_amarela": 56,
	"./data/Febre_amarela.js": 56,
	"./data/Mosquito": 53,
	"./data/Mosquito.js": 53,
	"./data/Untitled-1.css": 221,
	"./data/Zika": 57,
	"./data/Zika.js": 57,
	"./game/GamePage": 51,
	"./game/GamePage.js": 51,
	"./game/GameProvider": 24,
	"./game/GameProvider.js": 24,
	"./game/folder/Folder": 62,
	"./game/folder/Folder.css": 114,
	"./game/folder/Folder.js": 62,
	"./game/player/PlayerProvider": 16,
	"./game/player/PlayerProvider.js": 16,
	"./game/puzzle/ImageLoader": 34,
	"./game/puzzle/ImageLoader.js": 34,
	"./game/puzzle/Pieces": 27,
	"./game/puzzle/Pieces.js": 27,
	"./game/puzzle/Puzzle": 59,
	"./game/puzzle/Puzzle.css": 100,
	"./game/puzzle/Puzzle.js": 59,
	"./game/puzzle/modalWin/ModalWin": 60,
	"./game/puzzle/modalWin/ModalWin.css": 113,
	"./game/puzzle/modalWin/ModalWin.js": 60,
	"./game/puzzle/modalWin/warning/Warning": 61,
	"./game/puzzle/modalWin/warning/Warning.css": 112,
	"./game/puzzle/modalWin/warning/Warning.js": 61,
	"./game/puzzle/relatorio": 222,
	"./game/score/Score": 63,
	"./game/score/Score.css": 115,
	"./game/score/Score.js": 63,
	"./game/timer/Timer": 64,
	"./game/timer/Timer.js": 64,
	"./globalProvider": 14,
	"./globalProvider.js": 14,
	"./index": 36,
	"./index.css": 124,
	"./index.js": 36,
	"./midias/images/eic/eic_og.png": 223,
	"./midias/images/eic/logo.png": 224,
	"./midias/images/games/puzzles/chikungunya/curiosidades/1.jpg": 225,
	"./midias/images/games/puzzles/chikungunya/sintomas/1.jpg": 226,
	"./midias/images/games/puzzles/chikungunya/tratamento/2.jpg": 227,
	"./midias/images/games/puzzles/combate/como_se_protejer/3.jpg": 228,
	"./midias/images/games/puzzles/combate/duvidas_frequentes/1.jpg": 229,
	"./midias/images/games/puzzles/combate/residencia/1.jpg": 230,
	"./midias/images/games/puzzles/dengue/curiosidades/2.jpg": 231,
	"./midias/images/games/puzzles/dengue/sintomas/2.jpg": 232,
	"./midias/images/games/puzzles/dengue/tratamento/4.jpg": 233,
	"./midias/images/games/puzzles/febre_amarela/curiosidades/1.jpg": 234,
	"./midias/images/games/puzzles/febre_amarela/profilaxia/1.jpg": 235,
	"./midias/images/games/puzzles/febre_amarela/sintomas/2.jpg": 236,
	"./midias/images/games/puzzles/febre_amarela/tratamento/1.jpg": 237,
	"./midias/images/games/puzzles/mosquito/ciclo_de_vida/game.jpg": 238,
	"./midias/images/games/puzzles/mosquito/morte/game.jpg": 239,
	"./midias/images/games/puzzles/mosquito/nascimento_e_crescimento/game.jpg": 240,
	"./midias/images/games/puzzles/mosquito/origem/game.jpg": 241,
	"./midias/images/games/puzzles/mosquito/reproducao/game.jpg": 242,
	"./midias/images/games/puzzles/play.png": 243,
	"./midias/images/games/puzzles/zika/curiosidades/2.jpg": 244,
	"./midias/images/games/puzzles/zika/sintomas/1.jpg": 245,
	"./midias/images/games/puzzles/zika/tratamento/1.jpg": 246,
	"./midias/images/layout/puzzle.jpg": 247,
	"./modal/Modal": 20,
	"./modal/Modal.css": 111,
	"./modal/Modal.js": 20,
	"./music/Music": 71,
	"./music/Music.css": 125,
	"./music/Music.js": 71,
	"./puzzleMenu/PuzzleMenu": 50,
	"./puzzleMenu/PuzzleMenu.css": 98,
	"./puzzleMenu/PuzzleMenu.js": 50,
	"./rank/Rank": 66,
	"./rank/Rank.css": 119,
	"./rank/Rank.js": 66,
	"./rank/select/Select": 67,
	"./rank/select/Select.css": 118,
	"./rank/select/Select.js": 67,
	"./serviceWorker": 126,
	"./serviceWorker.js": 126,
	"./setupTests": 127,
	"./setupTests.js": 127,
	"./store/storeRanking": 25,
	"./store/storeRanking.js": 25,
	"./topMenu/TopMenu": 72,
	"./topMenu/TopMenu.css": 162,
	"./topMenu/TopMenu.js": 72
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96;